var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var PositionIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 70,
    glyphHeight: 70,
    glyphOffsetY: 3
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08618 59.1768C12.7668 51.3289 23.2185 46.5217 34.8721 46.5217C46.5256 46.5217 56.9773 51.3289 64.658 59.1768C66.4968 57.0034 68.1023 54.6257 69.4353 52.0833C64.1006 46.8962 57.6006 42.9043 50.3154 40.6782C54.9067 36.5044 57.8286 30.4521 57.8286 23.5652C57.8286 10.8347 47.6025 0.608643 34.8721 0.608643C22.1416 0.608643 11.9155 10.8347 11.9155 23.5652C11.9155 30.2434 14.8374 36.2957 19.4287 40.6782C12.1438 43.1064 5.6438 46.9084 0.309082 52.0837C1.64209 54.6262 3.24731 57.0034 5.08618 59.1768ZM49.4807 23.5652C49.4807 31.7043 43.0112 38.1738 34.8721 38.1738C26.7329 38.1738 20.2634 31.7043 20.2634 23.5652C20.2634 15.426 26.7329 8.95654 34.8721 8.95654C43.0112 8.95654 49.4807 15.426 49.4807 23.5652ZM34.8721 50.6956C29.6545 50.6956 25.4807 54.8694 25.4807 60.0869C25.4807 65.3042 29.6545 69.4783 34.8721 69.4783C40.0894 69.4783 44.2634 65.3042 44.2634 60.0869C44.2634 54.8694 40.0894 50.6956 34.8721 50.6956ZM33.4111 64.6782L32.5764 63.8433L31.9502 63.2173L29.0286 60.0869L30.4895 58.626L33.4111 61.7563L39.2546 55.7043L40.7156 57.165L33.4111 64.6782Z"
  }));
};
export var PositionIconGlyph = function (props) {
  return React.createElement(PositionIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};